(function () {
  const sections = document.querySelectorAll('[data-reviewsio-section]');
  if (!sections.length) return;

  let scriptLoading = false;
  let scriptLoaded = false;

  function loadWidgetScript() {
    return new Promise(function (resolve, reject) {
      if (typeof carouselInlineWidget === 'function') {
        resolve();
        return;
      }

      if (scriptLoaded) {
        resolve();
        return;
      }

      if (scriptLoading) {
        document.addEventListener('reviewsio:ready', resolve, { once: true });
        return;
      }

      scriptLoading = true;

      const script = document.createElement('script');
      script.src = 'https://widget.reviews.co.uk/carousel-inline-iframeless/dist.js';
      script.defer = true;
      script.onload = function () {
        scriptLoaded = true;
        document.dispatchEvent(new Event('reviewsio:ready'));
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initSection(section) {
    const configId = section.dataset.configId;
    const widgetId = 'reviewsio-carousel-' + configId;
    const container = document.getElementById(widgetId);

    if (!container || container.dataset.reviewsioInitialized === 'true') return;

    const config =
      window.__fdcHomeReviewsConfig && window.__fdcHomeReviewsConfig[configId];

    if (!config) return;

    loadWidgetScript()
      .then(function () {
        container.dataset.reviewsioInitialized = 'true';
        new carouselInlineWidget(widgetId, config);
      })
      .catch(function () {
        container.innerHTML =
          '<p class="fdc-home-reviews__unavailable">Reviews are currently unavailable.</p>';
      });
  }

  sections.forEach(function (section) {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          if (
            entries.some(function (entry) {
              return entry.isIntersecting;
            })
          ) {
            observer.disconnect();
            initSection(section);
          }
        },
        { rootMargin: '250px 0px' }
      );

      observer.observe(section);
      return;
    }

    initSection(section);
  });
})();
